module.exports = __webpack_public_path__ + "static/img/cover16.9e8bdef5.jpg";